export default __webpack_public_path__ + "static/assets/8e5a33f8b13b50ff97fde60c051fd782.png";